import { lazy } from 'react';

import Loadable from '../components/Loadable';

// ---- Lazy imports ----
const LoginPage = Loadable(lazy(() => import('../pages/auth/Login')));
const EmployeeProfile = Loadable(lazy(() => import('../pages/employeeprofile/EmployeeProfile')));
const ForgotPassword = Loadable(lazy(() => import('../pages/resetpassword/ForgotPassword')));

const TermsConditionsPage = Loadable(lazy(() => import('../pages/auth/TermsOfService')));
const PrivacyPolicyPage = Loadable(lazy(() => import('../pages/auth/PrivacyPolicy')));

// ---- Auth & public routes (MinimalLayout) ----
const AuthenticationRoutes = {
  path: '/',
  children: [
    { path: '/login', element: <LoginPage /> },
    { path: '/privacypolicy', element: <PrivacyPolicyPage /> },
    { path: '/termsofservice', element: <TermsConditionsPage /> },
    { path: '/employeeprofile', element: <EmployeeProfile /> },
    { path: '/forgotpassword', element: <ForgotPassword /> }
  ]
};

export default AuthenticationRoutes;
